import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { SessionWidgetService } from "../../../../../../modules/shared/services/session-widget.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "widget-config-page",
    templateUrl: "./widget-config-page.view.html",
    providers: []
})
export class WidgetConfigPageView implements OnInit {
    baseUrl = "";
    expansionStyle = "";
    sessionWidgetConfig: any = {};
    widgetConfiguration: any = {};
    themeConfiguration: any = {};
    selectedSessionWidget: any = {};
    displayThemeConfiguration = false;

    constructor(public sharedService: SharedService,
        private sessionWidgetService: SessionWidgetService,
         private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            this.sessionWidgetConfig = this.sharedService.sessionLayoutConfig[this.baseUrl];
            this.expansionStyle = this.sharedService.expansionStyle;
            this.selectedSessionWidget = this.sharedService.selectedSessionWidget;
            this.displayThemeConfiguration = this.selectedSessionWidget.widgetThemeCustomization;
            this.loadWidgetThemeConfiguration();
        }
    }

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            this.sessionWidgetConfig = this.sharedService.sessionLayoutConfig[this.baseUrl];
            this.expansionStyle = this.sharedService.expansionStyle;
            this.selectedSessionWidget = this.sharedService.selectedSessionWidget;
            this.displayThemeConfiguration = this.selectedSessionWidget.widgetThemeCustomization;
            this.loadWidgetThemeConfiguration();
        }
    }

    loadWidgetThemeConfiguration() {
        this.widgetConfiguration = this.sessionWidgetConfig.widget.applyCatalogConfiguration ? this.sessionWidgetConfig.widget.configuration : this.sessionWidgetConfig.widget.widgetConfiguration.color;
        this.themeConfiguration = this.sessionWidgetConfig.widget.applyCatalogConfiguration ? this.sessionWidgetConfig.widget.themeConfiguration : this.sessionWidgetConfig.widget.widgetConfiguration.theme;
        if(this.widgetConfiguration == null || this.themeConfiguration == null) {
            this.loadDefaultCatalogTheme();
        }
    }

    resetLoading: boolean = false;

    resetThemeConfiguration() {
        this.resetLoading = true;
        setTimeout(() => {
            this.loadDefaultCatalogTheme();
            this.resetLoading = false;
        }, 1000);
    }

    loadDefaultCatalogTheme() {
        let configuration = {
            'widgetBackgroundColor': 'white',//--widget-background-color
            'widgetTitleTextColor': 'black', //--widget-title-text-color
            'widgetTitleBackgroundColor': '#f3f3f3', //--widget-title-background-color
            'widgetButtonTextColor': 'black', //--widget-button-text-color
            'widgetButtonBackgroundColor': 'grey', //--widget-buttons-background-color
            'widgetItemBackgroundColor': 'white', //--widget-item-background-color
            'carouselArrowBoxColor': 'black', // --carousel-arrow-box-color
            'carouselArrowColor': 'white', //--carousel-arrow-color
            'carouselDotsColor': 'black', //--carousel-dots-color
            'carouselDotsInactiveColor': 'red' //--carousel-dots-inactive-color
        };

        let themeConfig = {
            'theme': 'custom',
            'primary': '#D50000',
            'secondary': '#6A1B9A',
            'background': '#FFFFFF',
            'text': '#FFFFFF',
            'bodyText': '#000000'
        };

        if(this.sessionWidgetConfig.widget.applyCatalogConfiguration) {
            if(this.displayThemeConfiguration) {
                this.sessionWidgetConfig.widget.themeConfiguration = themeConfig;
                this.themeConfiguration = this.sessionWidgetConfig.widget.themeConfiguration;
            } else {
                this.sessionWidgetConfig.widget.configuration = configuration;
                this.widgetConfiguration = this.sessionWidgetConfig.widget.configuration;
            }
        }
    }

    toggleApplyCatalogConfiguration(ev) {
        this.sessionWidgetConfig.widget.applyCatalogConfiguration = !this.sessionWidgetConfig.widget.applyCatalogConfiguration;
        this.loadWidgetThemeConfiguration();
    }
}
